import { useState, useEffect } from "react";
import { getMoodCount, getSelfCareCount, getTestCount } from "../services/apis";
import { useAuth } from "../context/authContext";
import { DEMO_DATA } from "../utils/demoData";

const useFeatures = () => {
  const { code } = useAuth();
  const [features, setFeatures] = useState({
    testCount: 0,
    moodCount: 0,
    selfCareCount: 0,
  });
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const demo = DEMO_DATA[code];

  useEffect(() => {
     if (demo) return;
    const fetchFeatures = async () => {
      try {
        setLoading(true);
        const [testData, moodData, selfCareData] = await Promise.all([
          getTestCount(code),
          getMoodCount(code),
          getSelfCareCount(code),
        ]);

        
        const totalUses =
          testData.data.totalTests +
          moodData.data.totalMoodTracks +
          selfCareData.data;
        setFeatures({
          testCount: isNaN(
            Math.round((testData.data.totalTests / totalUses) * 100)
          )
            ? 0
            : Math.round((testData.data.totalTests / totalUses) * 100),
          moodCount: isNaN(
            Math.round((moodData.data.totalMoodTracks / totalUses) * 100)
          )
            ? 0
            : Math.round((moodData.data.totalMoodTracks / totalUses) * 100),
          selfCareCount: isNaN(
            Math.round((selfCareData.data / totalUses) * 100)
          )
            ? 0
            : Math.round((selfCareData.data / totalUses) * 100),
        });
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchFeatures();
  }, [code]);
   if (demo) return { features: demo.features, loading: false, error: null };

  return { features, loading, error };
};

export default useFeatures;
